<div
  class="stars"
  [attr.aria-label]="'Rating of this customer is ' + ((data ?? 0) / 100) * 5 + ' stars out of 5.'"
  iuNumberAnimation
  [outputText]="false"
  [data]="data ?? 0"
  (numberEmitter)="bindValue($event)"
  style="--rating: {{ animatedValue }};"></div>
